import axiosInstanceNew from "../lib/axiosinstanceNew";

const AttendanceModel = class {

    async getcycle(id) {

        return (
            await axiosInstanceNew.get(`attendance/getAllCycle/${id}`)
        )
    }
    
    async GetAllCLass(status,query = []) {

        return await axiosInstanceNew.get(`attendance/getAllClass${status}&${new URLSearchParams(query)}`);
    }
    async GetAllCycle(data) {

        return await axiosInstanceNew.get(`attendance/getAllCycle/${data}`, data);
    }
    async GetAllAttendanceList(data, data1, type = "") {
        let add = "";
        add = add.toLowerCase();
        if (type !== "") {
            add = '&class_type=' + type;
        }
        return await axiosInstanceNew.get(`attendance?class_id=${data}&classcycle_id=${data1}${add}`, data);

    }
    async GetAllAttendanceLists(data) {
       
        return await axiosInstanceNew.get(`attendance?class_id=${data}`, data);

    }
    async AttendanceAddRemark(data, data1) {
        return await axiosInstanceNew.get(`attendance/remark?${data}, data`);
    }

    async AttendanceAddRemark(id, data) {
        return await axiosInstanceNew.put(`attendance/remark/${id}`, data);
    }


    async GetClassById(id) {

        return await axiosInstanceNew.get(`class/${id}`);
    }

    async MarkAttendance(data) {
        return await axiosInstanceNew.post(`attendance/manual`, data);
    }

    async GetAttendanceDetail(attendanceId) {
        return await axiosInstanceNew.get(`attendance/${attendanceId}`);

    }

    async AddRecovery(attendanceId, data) {
        return await axiosInstanceNew.post(`attendance/addRecovery/${attendanceId}`, data);
    }

    async UpdateAttendance(attendanceId, data) {
        return await axiosInstanceNew.put(`attendance/${attendanceId}`, data);
    }
    async Attendancedelete(id) {
        return await axiosInstanceNew.delete(`attendance/${id}`);
    }
    async getclassbyparent(id){
        return await axiosInstanceNew.get(`attendance/getAllClass?parent_id=${id}`);
    }
    async getclassbytutor(id){
        return await axiosInstanceNew.get(`attendance/getAllClass?tutor_id=${id}`);
    }
};

export default new AttendanceModel();

